import React from 'react';
import Image from 'components/Image'
const BeachConditionsFlag = () => {
	const [flag, setFlag] = React.useState('');
	const [conditions, setConditions] = React.useState('');

	React.useEffect(() => {
		const getFlag = async () => {
			const response = await fetch(`${process.env.GATSBY_ZMS_API_URL}beach/conditions/get/`);
			const data = await response.json();
			setFlag(data.data.flag);
			setConditions(data.data.conditions);
		}
		getFlag();
	}, []);

	return (
		<>
			{ flag && <h3>Current Conditions: <Image style={{ height: "2rem" }} src={flag} alt={conditions} /></h3> }
			<h3>For Gulf conditions and flag updates, text "SAFETY" to <a href="tel:31279">31279</a>.</h3>
		</>
	);
}

export default BeachConditionsFlag;